'use strict';

// Not SFRA 6x script upgrade compatible.Selective changes applied.

var states = require('storefront/util/states');
var util = require('improove/util/util');
import debounce from 'shared/js/util/debounce';

import siteConfig from 'shared/js/siteConfig';

var menuBranchCache = {};
var menuBranchesRequest = null;

/**
 * Open the level 2 menu and mark the active menu if we are in PLP.
 *
 * @returns {void}
 */
function openCurrentCategory() {
    var currentCategoryPath = document.querySelector('.js_current-category-path');
    if (currentCategoryPath && currentCategoryPath.dataset.currentCategoryPath !== 'null') {
        var path = JSON.parse(currentCategoryPath.dataset.currentCategoryPath);
        var selector = path.reduce((result, item) => {
            return (result && (result + ', ')) + '.menu-level-1-item[data-category-id="' + item + '"], .menu-level-2-item[data-category-id="' + item + '"]';
        }, '');
        var items = document.querySelectorAll(selector);
        for (let i = 0; i < items.length; i++) {
            items[i].classList.add('selected');
        }
        var notSelected = document.querySelectorAll('.menu-level-1-item:not(.selected), .menu-level-2-item:not(.selected)');
        for (let i = 0; i < notSelected.length; i++) {
            notSelected[i].classList.add('not-selected');
        }
    }
}

/**
 * Extract the L2 menu root from an AJAX HTML response.
 * @param {string} html
 * @returns {string}
 */
function normalizeMenuBranchHtml(html) {
    if (!html) {
        return '';
    }

    var $tmp = $('<div>').append($.parseHTML(html, document, false));
    var $branch = $tmp.children('.menu-level-2-container');
    if (!$branch.length) {
        $branch = $tmp.find('.menu-level-2-container').first();
    }

    return $branch.length ? $branch.prop('outerHTML') : '';
}

/**
 * Whether the pointer/focus is still on this top-level menu item.
 * @param {JQuery} $item
 * @returns {boolean}
 */
function isMenuItemEngaged($item) {
    if (!$item || !$item.length) {
        return false;
    }

    if ($item.is(':hover')) {
        return true;
    }

    var active = document.activeElement;
    return !!(active && $item[0].contains(active));
}

/**
 * Inject cached/normalized branch HTML into a top-level item when missing.
 * @param {JQuery} $item
 * @param {string} html
 * @returns {boolean} true when a branch container is present after inject
 */
function injectMenuBranch($item, html) {
    if ($item.find('.menu-level-2-container').length) {
        return true;
    }

    var branchHtml = normalizeMenuBranchHtml(html);
    if (!branchHtml) {
        return false;
    }

    $item.append(branchHtml);
    return $item.find('.menu-level-2-container').length > 0;
}

/**
 * Start (or reuse) the single fetch of all menu branches and store the HTML of each branch in cache.
 * Does not inject into the DOM.
 * @returns {JQuery.jqXHR|null}
 */
function fetchMenuBranches() {
    if (menuBranchesRequest) {
        return menuBranchesRequest;
    }

    var url = $('.menu-category-level-1').attr('data-menu-branches-url');
    if (!url) {
        return null;
    }

    menuBranchesRequest = $.ajax({
        url: url,
        method: 'GET',
        dataType: 'html'
    }).done(function (html) {
        var $tmp = $('<div>').append($.parseHTML(html, document, false));
        $tmp.find('[data-menu-branch]').each(function () {
            var branchHtml = normalizeMenuBranchHtml(this.innerHTML);
            if (branchHtml) {
                menuBranchCache[this.getAttribute('data-menu-branch')] = branchHtml;
            }
        });
    }).fail(function () {
        // Allow a later hover or click to try again
        menuBranchesRequest = null;
    });

    return menuBranchesRequest;
}

/**
 * Prefetch all lazy menu branches so first hover is usually cached.
 * @returns {void}
 */
function prefetchMenuBranches() {
    if ($('.menu-level-1-item[data-menu-branch]').length) {
        fetchMenuBranches();
    }
}

/**
 * Lazily fetch and inject L2/L3 menu branch HTML for a top-level item.
 * @param {JQuery} $item
 * @param {Function} callback
 */
function ensureMenuBranch($item, callback) {
    var done = typeof callback === 'function' ? callback : function () {};

    if ($item.find('.menu-level-2-container').length) {
        done();
        return;
    }

    var cgid = $item.attr('data-category-id');

    if (!$item.is('[data-menu-branch]')) {
        done();
        return;
    }

    if (menuBranchCache[cgid]) {
        injectMenuBranch($item, menuBranchCache[cgid]);
        done();
        return;
    }

    var request = fetchMenuBranches();
    if (!request) {
        done();
        return;
    }

    request
        .done(function () {
            injectMenuBranch($item, menuBranchCache[cgid]);
            done();
        })
        .fail(function () {
            done();
        });
}

/**
 * Open the desktop L2 panel for a top-level item.
 * @param {JQuery} $item
 * @returns {void}
 */
function openDesktopMenuBranch($item) {
    var $branch = $item.find('.menu-level-2-container').first();
    if (!$branch.length) {
        return;
    }

    $('.menu-main-container').addClass('active');
    $('.menu-level-1-container').addClass('level-2-active');
    $('.menu-level-2-container').removeClass('menu-active-container');
    $branch.addClass('menu-active-container');
    $('body').addClass('no-scroll');
}

/**
 * Close the desktop L2 panel for a top-level item.
 * @param {JQuery} $item
 * @returns {void}
 */
function closeDesktopMenuBranch($item) {
    $('.menu-main-container').removeClass('active');
    $('.menu-level-1-container').removeClass('level-2-active');
    $item.find('.menu-level-2-container').removeClass('menu-active-container');
    $('body').removeClass('no-scroll');
}

// Reset Menu Method
var resetMenu = function () {
    var containers = $('.menu-level-2-container, .menu-level-3-container');
    containers.each(function (i, el) {
        if ($(el).hasClass('menu-active-container')) {
            $(el).removeClass('menu-active-container');
        }
    });
    $('.menu-level-1-container').removeClass('level-2-active level-3-active');
    $('.menu-back-action').removeClass('show-button');
    $('.menu-level-1-item').unbind('mouseenter');
    $('.menu-level-1-item').unbind('mouseleave');
    $('.menu-level-3-item').unbind('click');
    if (!siteConfig.isSite('FM')) {
        $('.menu-level-1-item').unbind('click'); // #CDIFF #DONE FM does not have that line
    }
    $('.menu-level-2-item').unbind('click');
    $('.menu-back-action').unbind('click');
    $('.menu-parent-category').unbind('click');
    if (!siteConfig.isSite('FM', 'BS')) {
        $('.menu-parent-category-se').unbind('click'); // BS, FM don't have that line
    }
};

var menu = {};
menu.init = function init() {
    let menuTimeout = null;
    states.add('menu', $('.state-container--menu'), $('.menu-state-trigger'), {
        onActivate: function () {
            if (menuTimeout) {
                clearTimeout(menuTimeout);
                menuTimeout = null;
            }

            menuTimeout = setTimeout(function () {
                $('.menu-main-container').addClass('active');
                menuTimeout = null;
            }, 0);
        },
        onDeactivate: function () {
            if (menuTimeout) {
                clearTimeout(menuTimeout);
                menuTimeout = null;
            }
            menuTimeout = setTimeout(function () {
                $('.menu-main-container').removeClass('active');
                resetMenu();
                $('.header-hamburger-menu-icon').trigger('focus');
                menuTimeout = null;
            }, 0);
        }
    });

    function bindMobileLevelHandlers() {
        // Go to Sub menu Level 3
        $('.menu-level-2-item').on('click', function (e) {
            // Categories without subcategories render a desktop-only (.show-for-x-large) level 3 container
            var $level3Container = $(this).children('.menu-level-3-container').not('.show-for-x-large');
            if ($level3Container.length) {
                e.preventDefault();
                $('.menu-level-1-container').addClass('level-3-active');
                $level3Container.addClass('menu-active-container');
                $('#menu-state-container').scrollTop(0);
            } else {
                e.stopPropagation();
            }
        });

        // Stop Propagation level 3 and for campaign pages in menu list
        $('.menu-level-3-item, .menu-content-list').off('click.menuLazy').on('click.menuLazy', function (e) {
            e.stopPropagation();
        });

        // #CDIFF #DONE GG, PF has line instead:
        var selectorMenuParentCategory;
        if (siteConfig.isSite('GG', 'PF')) {
            selectorMenuParentCategory = '.menu-parent-category, .menu-parent-category-se';
        } else {
            selectorMenuParentCategory = '.menu-parent-category';
        }
        $(selectorMenuParentCategory).off('click.menuLazy').on('click.menuLazy', function (event) {
            event.stopPropagation();
        });
    }

    function loadMenu() {
        resetMenu();
        if (util.getScreenSize() === 'small' || util.getScreenSize() === 'medium') {
            // Go to Sub menu level 2
            if ($('body').hasClass('state--menu')) {
                $('.menu-main-container').addClass('active');
            }

            $('.menu-level-1-item').on('click', function (e) {
                var $item = $(this);
                var hasBranch = $item.find('div').hasClass('menu-level-2-container');
                var canLoadBranch = $item.is('[data-menu-branch]');

                if (hasBranch || canLoadBranch) {
                    e.preventDefault();
                    ensureMenuBranch($item, function () {
                        $('.menu-level-1-container').addClass('level-2-active');
                        $item.find('.menu-level-2-container').addClass('menu-active-container');
                        $('.menu-back-action').addClass('show-button').trigger('focus');
                        bindMobileLevelHandlers();
                    });
                }
            });

            bindMobileLevelHandlers();

            // Button go back on Sub menu
            $('.menu-back-action').on('click', function () {
                let level1c = $('.menu-level-1-container');
                if (level1c.hasClass('level-3-active')) {
                    level1c.removeClass('level-3-active');
                    $('.menu-level-3-container').removeClass('menu-active-container');
                } else if (level1c.hasClass('level-2-active')) {
                    level1c.removeClass('level-2-active');
                    $('.menu-level-2-container').removeClass('menu-active-container');
                    $('.menu-back-action').removeClass('show-button');
                    $('.close-state-trigger').trigger('focus');
                }
            });
        } else if (
            (siteConfig.isSite('BS', 'SN') && util.getScreenSize() === 'large')
            || (siteConfig.isSite('FM', 'GG', 'PF') && util.getScreenSize() !== 'small')
        ) { // #CDIFF #DONE FM, GG, PF have !== 'small' instead
            // Only for Desktop
            $('.menu-level-1-item')
                .on('mouseenter focusin', function () {
                    var $item = $(this);
                    ensureMenuBranch($item, function () {
                        // Open when response arrives if pointer/focus is still on the item
                        if (!isMenuItemEngaged($item)) {
                            return;
                        }
                        openDesktopMenuBranch($item);
                    });
                })
                .on('mouseleave', function () {
                    closeDesktopMenuBranch($(this));
                })
                .on('focusout', function (e) {
                    var $item = $(this);
                    var next = e.relatedTarget;
                    // Ignore focus moves that stay inside the same L1 item (incl. injected L2)
                    if (next && $item[0].contains(next)) {
                        return;
                    }
                    setTimeout(function () {
                        if (!isMenuItemEngaged($item)) {
                            closeDesktopMenuBranch($item);
                        }
                    }, 0);
                });

            // Use arrows to move across main categories in menu on desktop
            $('.menu-level-1-item').on('keydown', function (e) {
                var el;
                if (e.code == 'ArrowRight' && $(this).next().length) {
                    el = $(this).next();
                    $(el).find('a').trigger('focus');
                } else if (e.code == 'ArrowRight' && !$(this).next().length) {
                    $('.menu-page-item:first-child a').trigger('focus');
                }

                if (e.code == 'ArrowLeft' && $(this).prev().length) {
                    el = $(this).prev();
                    $(el).find('a').trigger('focus');
                }
            });
        }
    }

    $(window).on(
        'resize',
        debounce(function () {
            loadMenu();
        }, 200)
    );

    $(document).ready(function () {
        $('.header-hamburger-menu-icon').on('click', function () {
            loadMenu();
            openCurrentCategory();
            setTimeout(function () {
                $('.close-state-trigger').trigger('focus');
            }, 50);
        });
    });

    loadMenu();
    openCurrentCategory();

    // Warm menu branch cache immediately so early hovers can reuse in-flight requests
    prefetchMenuBranches();
};

module.exports = menu;
